module.exports = __webpack_public_path__ + "img/sld_mfm_aux_dark.bfdf4430.svg";